import "./App.css";
import CustomRouter from "./router";
import Header from "./components/Header";
import Footer from "./components/Footer";
import ReactGa from "react-ga";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import axiosInstance from "./components/axiosInstance";

import { sign_in, user_data, cart_data, license_data, order_data } from "./redux";

function App() {
  const dispatch = useDispatch();
  const location = useLocation();

  //grab the current authentication state from Redux to avoid duplicate network calls
  const isAuth = useSelector((state) => state.session.isAuth)

  useEffect(() => {
    ReactGa.initialize("UA-202975781-1");
    ReactGa.pageview(window.location.pathname + window.location.search);
  }, []);

  useEffect(() => {
    const token = localStorage.getItem("accessToken")

    if (token && token !== "undefined" && token !== "null" && !isAuth) {
      axiosInstance
        .get("users/is_authenticated/")
        .then((res) => {
          if (res.data.ok) {
            dispatch(sign_in());
            dispatch(cart_data(res.data.cart));
            dispatch(license_data(res.data.licenses));
            dispatch(order_data(res.data.orders));
            dispatch(user_data(res.data.user));
          }
        })
        .catch((err) => {
          console.error("Session re-hydration check failed:", err);
        });
    }
  }, [dispatch, location.pathname, isAuth]);

  return (
    <div className="App">
      <Header />
      <main className="app-content">
        <CustomRouter />
      </main>
      <Footer />
    </div>
  );
}

export default App;